// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3UUpj","content":"styles_content__2OFSg","checkbox":"styles_checkbox__1dxqT","checkboxLabel":"styles_checkboxLabel__20rz4"};